<template>
<div id="app">
  <div class="rescue">
    <div @click="tolist" class="back">&lt;&lt;返回上一页</div>
    <h5>救援服务</h5>
    <div v-if="dataId == 5">
         <div class="tip1">
      前言:用户自此清单生效之日起，在第三方中转国认可的医疗机构被诊断罹患新型冠状病毒（COVID-19）感染的肺炎后，大救星安排紧急医疗转运、医疗送返、休养期饭店住宿等服务，费用由大救星承担：
    </div>
      
    <ul>
      <!-- <li>
        <p class="tip1 tit"> <span class="spanclass"></span></p>
        <p class="list_desc">
  
        </p>
      </li> -->
      <li>
        <p class="tip1 tit"> <span class="spanclass">紧急医疗转运</span></p>
        <p class="list_desc">
     若经大救星医生和咨询医生，及主治医生共同确定，用户所在医院医疗设施无法满足病情需要，大救星应在适宜的医疗监督下，通过适当的转运方式将用户运送至最近的且能够提供必要医疗设施的医疗场所。最高给付金额以清单载明的相应的限额为限。
注：用户由于确诊新冠肺炎需要住院救治或酒店隔离导致行程延误，且已购买的从第三方中转国到中国的机票不能改签或使用的情况下，在其新冠肺炎康复后大救星可承担一张单程经济舱回到中国机票费用，方案一，最高限额为2万人民币，方案二，最高限额为3万人民币。
        </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">感染新冠肺炎确诊金</span></p>
        <p class="list_desc">
        在本清单的保障期间内，用户在大救星认可的医疗机构初次被诊断罹患新型冠状病毒（COVID-19）肺炎，大救星根据清单载明的金额给付感染新冠肺炎确诊金。本救援服务清单对该用户的服务保障责任终止。
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">医疗送返</span></p>
        <p class="list_desc">
        若大救星医生及主治医生确定因医疗必须，大救星应在适宜的医疗监督下，在得到医学许可的前提下，将用户安排运送至原出发地或距其原出发地较近的医疗场所或康复机构。最高给付金额以清单载明的相应的限额为限。且此送返服务需要严格遵守中国及第三方中转国的新冠肺炎疫情管控政策。
      </p>
      </li>
    </ul>
    <ul>
      <li>
        <p class="tip1 tit"><span class="spanclass">当地安葬/丧葬保险金</span></p>
        <p class="list_desc">若用户在第三国中转过程中不幸罹患新冠肺炎完全且直接导致在境外身故的，根据用户亲属的要求并在不违反当地法律的情况下，大救星或其授权代表安排在事发当地安葬用户。大救星承担安葬费用。最高给付金额以清单载明的相应的限额为限</p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">遗体/骨灰送返</span></p>
        <p class="list_desc">
        如用户不幸身故，应家属的要求，大救星将安排将其遗体运送回其原出发地附近的经授权的殡仪馆并支付相关费用或者遗体在当地进行火化，安排骨灰盒运送回国。大救星将全程安排，包括确认当地具备资质的殡仪馆、太平间或能够直接安排尸体运送的机构、主动和使领馆沟通、协调完成所有文件的准备并取得所有法律放行文件、促进取得死亡证明、购置最基本标准的骨灰盒或棺椁以便进行转运、以及安排整个转运过程。最高给付金额以清单载明的相应的限额为限。
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">休养期饭店住宿</span></p>
        <p class="list_desc">
        如经用户的主治医生和大救星共同认为用户出院后因医疗上的需要应在当地休养，大救星将安排该用户在出院后立即入住当地一间普通酒店以便其休养，我司负责承担酒店房间费用，最高以清单中载明的相应的服务限额为限
      </p>
      </li>
    </ul>
    <ul>
      <li>
        <p class="tip1 tit"><span class="spanclass">电话医生咨询</span></p>
        <p class="list_desc">
        如用户在第三国中转期间不幸罹患新冠肺炎，在其住院或隔离期间，大救星救援医生可根据客户的具体病情提供相应医疗咨询及指导服务。
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">住院期间医疗病情监控及指导</span></p>
        <p class="list_desc">
        大救星医务人员会监护用户入院后的医疗状况，与用户的主治医生或医院定期保持联系，并向其家庭成员传递合法的必要医疗情况信息。
      </p>
      </li>
        <li>
        <p class="tip1 tit"><span class="spanclass">协助安排就医</span></p>
        <p class="list_desc">
        根据用户身体状况、病情等，大救星协助用户在当地尽可能符合治疗要求的、经我公司审核认证或与大救星有合作关系的医疗机构（医生、医院、诊所等）就医。如病情严重，大救星协助安排该用户住院治疗
      </p>
      </li>
    </ul>
       <ul>
      <li>
        <p class="tip1 tit"><span class="spanclass">紧急口讯传递</span></p>
        <p class="list_desc">
        大救星将传递和接收与家属间或雇主间的合法的紧急信息。
      </p>
      </li>
    </ul>
    </div>
     <div v-else-if="dataId == 6">
         <div class="tip1">
           用户在清单保障期间内，因遭受约定的意外伤害事故或突发急性病时，大救星可安排紧急医疗转运、医疗送返、电话医学咨询等服务，费用由大救星承担：
        </div>
    <ul>
      <li>
        <p class="tip1 tit"><span class="spanclass">紧急医疗转运</span></p>
        <p class="list_desc">
        若经大救星医生和咨询医生，及主治医生共同确定，用户所在医院医疗设施无法满足病情需要，大救星应在适宜的医疗监督下，通过适当的转运方式将用户运送至最近的且能够提供必要医疗设施的医疗场所。最高给付金额以清单载明的相应的限额为限。
        </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">医疗送返</span></p>
        <p class="list_desc">
        若大救星医生及主治医生确定因医疗必须，大救星应在适宜的医疗监督下，在得到医学许可的前提下，将用户安排运送至原出发地或距其原出发地较近的医疗场所或康复机构。最高给付金额以清单载明的相应的限额为限。且此送返服务需要严格遵守中国新冠肺炎疫情管控政策。 
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">遗体送返</span></p>
        <p class="list_desc">
        用户在清单保障期间内，因遭受约定的意外伤害事故或突发急性病并完全且直接导致其身故的。应家属的要求，大救星将安排将其遗体运送回其原出发地附近的经授权的殡仪馆并支付相关费用。大救星将全程安排，包括确认当地具备资质的殡仪馆、太平间或能够直接安排尸体运送的机构，促进取得死亡证明、购置最基本标准的棺椁以便进行转运、以及安排整个转运过程。最高给付金额以清单载明的相应的限额为限。
      </p>
      </li>
    </ul>
    <ul>
      <li>
        <p class="tip1 tit"><span class="spanclass">当地火化</span></p>
        <p class="list_desc">
        用户在清单保障期间内，因遭受此服务清单约定的意外伤害事故或突发急性病并完全且直接导致其身故的，根据用户亲属的要求并在不违反当地法律的情况下，大救星或其授权代表安排遗体在当地进行火化并承担相应费用。最高给付金额以此服务清单上载明的相应的服务限额为限。
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">电话医学咨询服务</span></p>
        <p class="list_desc">   
        当用户在清单保障期间内，如身体不适或遇到紧急医疗状况，可拨打救援服务电话得到大救星医生的医疗咨询服务。
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">紧急电话翻译服务</span></p>
        <p class="list_desc">
        当用户在清单保障期间内，由于语言障碍，大救星可提供短暂的电话翻译服务。如需第三方提供电话翻译服务，所产生的费用由用户承担。
      </p>
      </li>
    </ul>
    <ul>
      <li>
        <p class="tip1 tit"><span class="spanclass">递送必需药物和医疗用品</span></p>
        <p class="list_desc">
        在有医疗必要的情况下，大救星尽力协助安排为用户递送该用户护理、治疗所必需的而在该用户所在地无法获得的药物、药品及医疗用品。药物、药品或医疗用品的递送须遵守当地的法律规定。前述药物、药品及医疗用品的成本及其递送的费用需由用户自行承担。
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">递送必需药物和医疗用品</span></p>
        <p class="list_desc">
   
        在有医疗必要的情况下，大救星尽力协助安排为用户递送该用户护理、治疗所必需的而在该用户所在地无法获得的药物、药品及医疗用品。药物、药品或医疗用品的递送须遵守当地的法律规定。前述药物、药品及医疗用品的成本及其递送的费用需由用户自行承担。
      
      </p>
      </li>
        <li>
        <p class="tip1 tit"><span class="spanclass">紧急创伤咨询</span></p>
        <p class="list_desc">   
        为用户提供初步的在线处理意见，并按需求跟进推荐合适的医疗人员。
      </p>
      </li>
    </ul>
       <ul>
      <li>
        <p class="tip1 tit"><span class="spanclass">紧急信息传递</span></p>
        <p class="list_desc">     
        大救星将传递和接收用户与家属间或雇主间的合法的紧急信息。
      </p>
      </li>
    <li>
        <p class="tip1 tit"><span class="spanclass">医疗监控</span></p>
        <p class="list_desc">
        
        大救星医务人员会监护用户入院后的医疗状况，与用户的主治医生或医院定期保持联系，并向其家庭成员传递合法的必要医疗情况信息。
      </p>
      </li>
       <li>
        
      </li>
    </ul>
    </div>
    <div v-else-if="dataId == 7">
         <div class="tip1">
     大救星承担费用：用户自清单生效之日起30天等待期后，在其境外务工所在地国家且受中国大使馆或所在地国家认可的医疗机构初次被诊断罹患新型冠状病毒（COVID-19）感染的肺炎（以下简称新冠肺炎）后，大救星安排紧急医疗转运、医疗送返等服务，费用由大救星承担。
    </div>
    <ul>
      <li>
        <p class="tip1 tit"><span class="spanclass">紧急医疗转运</span></p>
        <p class="list_desc">
              若经大救星医生和咨询医生，及主治医生共同确定，用户所在医院医疗设施无法满足病情需要，大救星应在适宜的医疗监督下，通过适当的转运方式将用户运送至最近的且能够提供必要医疗设施的医疗场所。最高给付金额以清单载明的相应的保障额度为限。

        </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">医疗送返</span></p>
        <p class="list_desc">
        
        若大救星医生及主治医生确定因医疗必须，大救星应在适宜的医疗监督下，在得到医学许可且符合当地国家及中国的新冠疫情防控政策许可下，将用户安排运送至原出发地或距其原出发地较近的医疗场所或康复机构。最高给付金额以清单载明的相应的保障额度为限。
      
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">遗体/骨灰送返</span></p>
        <p class="list_desc">
       
        如用户初次罹患新冠肺炎完全且直接导致身故的，应家属的要求且符合当地国及中国的新冠疫情管控政策，大救星将安排将其遗体运送回其原出发地附近的经授权的殡仪馆并支付相关费用或者遗体在当地进行火化，安排骨灰盒运送回国。大救星将全程安排，包括确认当地具备资质的殡仪馆、太平间或能够直接安排尸体运送的机构、主动和使领馆沟通、协调完成所有文件的准备并取得所有法律放行文件、促进取得死亡证明、购置最基本标准的骨灰盒或棺椁以便进行转运、以及安排整个转运过程。最高给付金额以清单载明的相应的保障额度为限。
      
      </p>
      </li>
    </ul>
    <ul>
      <li>
        <p class="tip1 tit"><span class="spanclass">丧葬安排</span></p>
        <p class="list_desc">
        若用户因初次罹患新冠肺炎完全且直接导致在境外身故的，根据用户亲属的要求并在不违反当地法律及疫情防控政策的情况下，大救星或其授权代表安排在事发当地安葬用户。大救星承担安葬费用。最高给付金额以清单载明的相应的保障额度为限。
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">亲属探访</span></p>
        <p class="list_desc">
      
        若用户因初次罹患新冠肺炎导致住院且须接受超过连续超过八（8）天的住院治疗，大救星将安排一名成年亲属通过适当的交通工具前往探望，即安排相当于普通航班经济舱的往返机票以到达离用户所处医院最近的主要机场，以及实际支出的合理住宿费。最高以清单载明的相应的保障额度为限。如适用，家属自身应满足所有签证及旅行证件要求。
      
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">亲属前往处理后事</span></p>
        <p class="list_desc">
        
        若用户因初次罹患新冠肺炎完全且直接导致用户于出险后三十（30）天内在境外身故的，根据用户亲属的要求，经大救星许可，该用户的一名成年亲属可以前往用户身故地，大救星负责承担该名亲属一套往返用户身故地与亲属所在地的普通航班经济舱机票、船票、火车票或汽车票的费用以及实际支出的合理住宿费，最高以清单载明的相应的保障额度为限。
      
      </p>
      </li>
    </ul>
    <ul>
      <li>
        <p class="tip1 tit"><span class="spanclass">在线医疗指导</span></p>
        <p class="list_desc">
       
        如用户因初次罹患新冠肺炎，在其住院或隔离期间，大救星医疗团队可根据客户的具体病情提供相应的多次医疗咨询及指导服务，最高时长以清单载明的相应时长为限。
      
      </p>
      </li>
      <li>
        <p class="tip1 tit"><span class="spanclass">住院期间医疗病情监控及指导</span></p>
        <p class="list_desc">
        大救星医务人员会监护用户入院后的医疗状况，与用户的主治医生或医院定期保持联系，并向其家庭成员传递合法的必要医疗情况信息。
      </p>
      </li>
        <li>
        <p class="tip1 tit"><span class="spanclass">心理安抚</span></p>
        <p class="list_desc">
      
        如用户因初次罹患新冠肺炎，在其住院或隔离期间且精神压力较大的情况下，大救星人员可根据客户的具体情况进行必要的在线心理疏导及安抚关怀。
      
      </p>
      </li>
      
    </ul>
    <ul>
       <li>
        <p class="tip1 tit"><span class="spanclass">医疗机构/新冠检测机构推介</span></p>
        <p class="list_desc">
        如用户因初次罹患新冠肺炎，根据用户要求及其身体状况、病情等，大救星向用户介绍并推荐当地尽可能符合治疗要求的、经大救星审查认证或与大救星有合作关系的医疗机构或新冠检测机构。包括医生、医院等，内容包括名称、地址、电话、专长、工作时间等。
      </p>
      </li>
      <li>
        <p></p>
        <p class="list_desc">
        
      </p>
      </li>
    </ul>
       <!-- <ul>
      <li>
        <p><img src="./img/detail/icon7.png" alt="">紧急口讯传递</p>
        <p class="list_desc">
        大救星将传递和接收与家属间或雇主间的合法的紧急信息。
      </p>
      </li> -->
    
    </ul>
    </div>
    <div v-else>
         <div class="tip1">
      大救星承担费用:在符合救援条件的前提下大救星安排转运、送返等救援服务,费用由大救星承担,且救援无既往症、无地理区域、无危险运动以及无年龄限制。
    </div>
    <ul>
      <li>
        <p><img src="./img/detail/icon1.png" alt="">紧急医疗转运</p>
        <p class="list_desc">若经大救星医生和咨询医生,及主治医生共同确定,会员所在医院医疗设施无法满足病情需要,大救星应在适宜的医疗监督下通过适当的转运方式将会员运送至最近的且能够提供必要医疗设施的医疗场所。</p>
      </li>
      <li>
        <p><img src="./img/detail/icon2.png" alt="">医疗送返</p>
        <p class="list_desc">若大救星医生及主治医生确定因医大救星应在适宜的医疗监督下,在得到医学许可的前提下将会员安排运送至原出发地或距其原出发地较近的医疗场所或康复机构。如果会员出院日起算,取得商业航班飞行所需的医疗许可的时间超过14(含)天,可以其他适当的运送方式作为替代,如通过医疗救援飞机。根据案件必要性,医疗或非医疗运送均可能被提供</p>
      </li>
      <li>
        <p><img src="./img/detail/icon3.png" alt="">照顾未成年子女</p>
        <p class="list_desc">如果会员因事故或疾病的医疗情况或不幸身故而导致其随行的未成年子女无人照顾,大救星会帮助安排子女回家即安排相当于单程普通航班经济舱机票。必要时,安排随行人员护送</p>
      </li>
    </ul>
    <ul>
      <li>
        <p><img src="./img/detail/icon4.png" alt="">遗体送返或火化</p>
        <p class="list_desc">如果会员不幸身故,大星将安排将其遗体运送回其原出发地附近的经授权的殡仪馆并支付相关费用。大救星将全程安排,包括确认当地具备资质的殡仪馆、太平间或能够直接安排尸体运送的机构、主动和使领馆沟通协调完成所有文件的准备并取得所有法律放行文件、协助取得死亡证明、购置最基本标准的骨灰盒或棺椁用于骨灰或遗体的转运井安排整个转运过程。</p>
      </li>
      <li>
        <p><img src="./img/detail/icon5.png" alt="">安排亲友探访</p>
        <p class="list_desc">如果会员不幸身故,大星将安排将其遗体运送回其原出发地附近的经授权的殡仪馆并支付相关费用。大救星将全程安排,包括确认当地具备资质的殡仪馆、太平间或能够直接安排尸体运送的机构、主动和使领馆沟通协调完成所有文件的准备并取得所有法律放行文件、协助取得死亡证明、购置最基本标准的骨灰盒或棺椁用于骨灰或遗体的转运井安排整个转运过程。</p>
      </li>
      <li>
        <p><img src="./img/detail/icon6.png" alt="">医疗陪同服务</p>
        <p class="list_desc">旅行期间因意外伤害、突发重病需要紧急就诊时,可通过大救星平台联系星使,并得到4小时的翻译陪同服务(2小时次,不超过两次)。家庭款产品中,家庭成员共享该4小时星使陪同服务。由此实际产生的医疗费用由会员自行承担。</p>
      </li>
    </ul>
    <ul>
      <li>
        <p><img src="./img/detail/icon7.png" alt="">补办证件陪同服务</p>
        <p class="list_desc">旅行期间证件因被盗被抢需要补办手续时,可通过大救星平台联系星使,并得到一次性2小时的翻译陪同服务。家庭款产品中,家庭成员共享该2小时星使陪同服务。由此实际产生的补办证件费用由会员自行承担。</p>
      </li>
      <li>
        <p><img src="./img/detail/icon8.png" alt="">报案陪同服务</p>
        <p class="list_desc">旅行期间钱财因被盗被抢需要紧急报案或补办手续,可通过大救星平台联系星使,并得到一次性2小时的翻译陪同服务。家庭款产品中,家庭成员共享该2小时星使陪同服务。由此实际产生的报案费用由会员自行承担。</p>
      </li>
      <li></li>
    </ul>
    </div>
  <div class="safelist" v-if="dataId != 5 && dataId != 6 && dataId != 7">
    <div style="height:55px"></div>
    <h5>安全管家服务项</h5>
    <div class="safe_box" style="padding: 0 2vw;">
      <div class="tip1">
        大救星提供24小时免费咨询及安排服务,实际产生的第三方费用由会员自己承担,费用包括但不限于医疗费、保释金、医药费、应急现金费用、保镖费、律师费、紧急撤离第三方费用、体检费、食宿费、交通费、手续费等。
      </div>
      <ul>
        <li>
          <h6>星使服务</h6>
          <p>旅行期间证件因被盗被抢需要补办手续时,可通过大救星平台联系星使,并得到一次性2小时的翻译陪同服务。家庭款产品中,家庭成员共享该2小时星使陪同服务。由此实际产生的补办证件费用由会员自行承担。</p>
          
        </li>
        <li>
          <h6>应急现金协调</h6>
          <p>当会员遭遇可经证明的旅行紧急情况,导致没有经济来源,大救星将协助会员紧急周转其所需现金。但会员需要向大救星提供资金来源(比如其家人)或银行担保。</p>
        </li>
        <li>
          <h6>法律援助服务</h6>
          <p>会员可通过大救星平台在线查找全球各地律师,也可联系救援中心寻求帮助,发生的实际费用由会员承担。</p>
        </li>
        <li>
          <h6>紧急医疗咨询</h6>
          <p>大救星为会员提供医疗咨询、评估及向会员推荐具有资质的医疗机构或医生。没有网络或紧急情况会员也可拨打24小时救援服务专线86-10-61869191,得到相应的帮助。</p>
        </li>
      </ul>
      <ul>
        <li>
          <h6>入院担保</h6>
          <p>根据会员保障利益,由保险公司授权后,及时向国外的医院签发费用担保函以便会员能够入院治疗。(仅限于有保险且在保险范围内的会员,或有企业、家人担保支付)的医疗状况,与患者的主治医生或医院定期保持联系,并向其家庭成员传递合法的必要医疗情况信息。</p>
        </li>
        <li>
          <h6>紧急信息传递</h6>
          <p>大救星将传递和接收与家属间或雇主间的合法的紧急信息。</p>
        </li>
        <li>
          <h6>遗失行李或文件援助</h6>
          <p>大救星将协助寻找丢失的行李、证件、个人财物和或协助补票。</p>
          
        </li>
        <li>
          <h6>处方援助</h6>
          <p>若会员在旅途中需运送和或更换方药,与主治医生协商后,大救星将在可能的情况下依法运送和或协助更换。会员负责处方及药品费用。</p>
        </li>
      </ul>
      <ul>
        <li>
          <h6>安保服务</h6>
          <p>会员可通过大救星平台在线查找安保公司,也联系救援中心寻求帮助,发生的实际费用由会员承担。</p>
        </li>
        <li>
          <h6>协助安排境外旅行机构</h6>
          <p>通过大救星平台直联系目的国旅行机构或星使,以获得性价比高的旅行安排。</p>
        </li>
        <li>
          <h6>保释协调</h6>
          <p>大救星将基于法律规定或会员的要求,协助会员,并为会员提供或协调提供保释意见,并按需求跟进推荐合适的医疗人员。</p>
        </li>
        <li>
          <h6>文件翻译服务</h6>
          <p>为客户提供在旅行过程中需要的相关文件翻译服务的安排,翻译服务的费用客户自理。</p>
        </li>
      </ul>
    </div>
    
  </div>
  <div class="disclaimer" style="padding:0 0" v-if="dataId != 5 && dataId != 6 && dataId != 7">
    <h5>免责声明</h5>
    <ul>
      <li>
        <img src="./img/detail/3-icon.png" alt="">
        <div class="tk">
          <h4>发生下列任一种情形的,将不适用本服务：</h4>
          <p>1、以治疗为特定目的而进行的旅行</p>
          <p>2、因参与战争或叛乱行为而遭受的伤害</p>
          <p>3、从事违法行为</p>
          <p>4、自杀未遂</p>
          <p>5、使用毒品(但医生开具的处方除外)</p>
          <p>6、会员在被转移或需被转移至另一个具有相似医疗水平的医疗场所</p>
          <p>7、会员未持有有效护照及或有效的工作签证</p>
        </div>
      </li>
      <li>
        <img src="./img/detail/3-icon(1).png" alt="">
        <div class="tk">
          <h4>发生下列任一种情形的,大救星将不提供用户紧急医疗转运或安排医疗送返服务：</h4>
          <p>1、未获得医疗授权 </p>
          <p>2、当地医生可以治疗且不妨碍继续旅行的一般性受伤,如扭伤、轻  微骨折或不妨碍旅行的其他情况</p>
          <p>3、28周(含)以上的怀孕后期</p>
          <p>4、自杀未遂</p>
          <p>5、精神或神经性不适(已入院后发生的除外)</p>
        </div>
      </li>
    </ul>
    <div class="tip2">
      <h6>注<span>:</span></h6>
      <p>虽然紧急援助服务范围遍及全球,运送响应时间与事件发生地有直接关系。对于因罢工或其它无法控制的原因(包括但不限于天气情况、有无机场、飞行条件、有无高压舱、通讯系统、缺少适当的旅行证件或提供服务受到法律或法令的限制或禁止等情形的),导致无法提供服务或服务延迟的,大救星不承担任何责任。所有第三方咨询医生和律师等专业人员均为独立的合同方,不受大救星控制。对于其专业人员向用户提供服务所导致的任何执业过失,大救星不承担任何责任。</p>
    </div>
  </div>
    </div>
   
</div>
</template>

<script>
export default {
  data() {
    return {
      dataId: 1,
      listId: 1,
    };
  },
  created() {
    if (this.$route.params.pid) {
      this.dataId = this.$route.params.pid;
      this.listId = this.$route.params.id;
    }
    console.log(this.dataId);
    console.log(this.listId);
  },
  methods: {
    tolist() {
      this.$router.push({
        name: "rescuelist",
        params: {
          pid: this.dataId,
          id: this.listId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#app {
  background: #fff;
  * {
    box-sizing: border-box;
    -moz-box-sizing: border-box; /* Firefox */
    -webkit-box-sizing: border-box; /* Safari */
  }
  ul,
  ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  @mixin titH5 {
    font-size: 32px;
    color: #333;
    position: relative;
    text-align: center;
    padding: 55px 0;
  }
  @mixin pseudo {
    content: "";
    position: absolute;
    width: 40px;
    height: 2px;
    top: 50%;
    background-color: #333;
  }
  @mixin cssdefault {
    box-shadow: 0 0 4px 0 hsla(0, 0%, 60%, 0.5);
    -ms-transition: all 0.5s ease-in;
    -moz-transition: all 0.5s ease-in;
    -webkit-transition: all 0.5s ease-in;
    transition: all 0.5s ease-in;
  }
  @mixin csshover {
    -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }
  .tip1 {
    width: 100%;
    font-size: 18px;
    color: #333;
    background: #f3fbff;
    padding: 25px 30px;
    line-height: 30px;
    &::before {
      content: "";
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #00abfa;
    }
  }
  .rescue {
    padding: 0 17vw;
    .back {
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      font-size: 16px;
      color: #333;
      display: block;
      padding: 35px 0;
      cursor: pointer;
    }
    .tip1 {
      width: 100%;
      font-size: 18px;
      color: #333;
      background: #f3fbff;
      padding: 25px 30px;
      line-height: 30px;
      &::before {
        content: "";
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #00abfa;
      }
    }
    h5 {
      @include titH5;
      &::before {
        @include pseudo;
        left: 40%;
      }
      &::after {
        @include pseudo;
        right: 40%;
      }
    }
    ul {
      margin-top: 2.5vw;
      text-align: left;
      li {
        width: 18vw;
        p {
          img {
            vertical-align: middle;
            margin-right: 10px;
          }
          font-size: 16px;
          font-family: Microsoft YaHei;
          color: #333;
          margin-top: 1vw;
        }
        .list_desc {
          font-size: 14px;
          color: #666;
          line-height: 30px;
          background-color: #ffffff;
        }
      }
    }
  }

  .safelist {
    width: 100%;
    min-height: 70vw;
    background: url("./img/detail/cnt_bg.png") no-repeat;
    background-size: 100% 100%;
    margin-top: 45px;
    padding-bottom: 5vw;
    h5 {
      @include titH5;
      color: #fff;
      &::before {
        @include pseudo;
        left: 40%;
        background: #fff;
      }
      &::after {
        @include pseudo;
        right: 40%;
        background: #fff;
      }
    }
    .safe_box {
      padding: 0 15vw;
      .tip1 {
        background: #fdffff;
        margin-bottom: 2vw;
      }
      ul {
        li {
          width: 15vw;
          min-height: 14vw;
          /*height: 14vw;*/
          background: url("./img/detail/bg-2.png") no-repeat bottom;
          background-size: 100%;
          background-color: #fff;
          position: relative;
          margin-top: 1.5vw;
          cursor: pointer;
          @include cssdefault;
          h6 {
            width: 12vw;
            height: 2vw;
            border: 3px solid rgba(0, 171, 250, 1);
            border-radius: 4px;
            position: absolute;
            left: 1.5vw;
            top: -0.9vw;
            background: #fff;
            text-align: center;
            line-height: 1.7vw;
            color: #00abfa;
            font-size: 0.8333vw;
          }
          p {
            color: #666;
            font-size: 0.6vw;
            padding: 2vw 1.5vw;
            line-height: 22px;
          }
          &:nth-child(4n) {
            margin-right: 0;
          }
        }
        /*li:hover{
          @include csshover;
        }*/
      }
    }
  }
  .disclaimer {
    padding: 0 15vw;
    ul {
      li {
        width: 30vw;
        box-shadow: 0px 2px 18px 0px rgba(12, 45, 95, 0.23);
        border-radius: 4px;
        padding: 2.5vw 0;
        position: relative;
        img {
          position: absolute;
          left: 0;
          top: 2.5vw;
          margin-right: 25px;
        }
        .tk {
          padding: 0 1.5vw 0 8.5vw;
          h4 {
            height: 4vw;
            border-bottom: 1px dashed #e5e5e5;
            color: #333;
            font-size: 0.9vw;
            line-height: 22px;
            font-weight: normal;
            margin-bottom: 1.5vw;
          }
          p {
            font-size: 0.8vw;
            color: #666;
            line-height: 30px;
          }
        }
      }
    }
    h5 {
      @include titH5;
      &::before {
        @include pseudo;
        left: 35%;
      }
      &::after {
        @include pseudo;
        right: 35%;
      }
    }
  }
  .tip2 {
    margin-top: 35px;
    padding-bottom: 70px;
    h6 {
      width: 22px;
      height: 22px;
      background: #ff464e;
      margin-bottom: 15px;
      font-size: 18px;
      color: #fff;
      font-weight: normal;
      text-align: center;
      border-radius: 4px;
      span {
        background: transparent;
        color: #333;
        padding-left: 10px;
      }
    }
    p {
      font-size: 14px;
      color: #333;
      line-height: 30px;
    }
  }
  .tit {
    background-color: #ffffff !important;
    font-size: 16px !important;
    font-family: Microsoft YaHei !important;
    color: #333 !important;
    margin-top: 1vw !important;
    padding: 0 !important;
    margin-top: 1vw !important;
  }
  .spanclass {
    margin-left: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/rescuelist/rescuedetail.vue